const FILENAME_QUERY_PARAM = 'filename';

export function getFileNameFromUrl(url: string) {
  return new URL(url).searchParams.get(FILENAME_QUERY_PARAM);
}
